module.exports = __webpack_public_path__ + "img/Salutaria_Project_Logo_3.83d0111a.png";